<template>
  <div class="unescap-chart">
    <div ref="chartContainerRef"></div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { select as d3Select } from 'd3';
import _ from 'lodash';
import { MultiColumn } from '../unescap-viz/column-multi';
// import { MultiLine } from '../unescap-viz/multiline'
import { LayeredArea } from '../unescap-viz/layered-area';
import { StackedArea } from '../unescap-viz/stacked-area';
import { PieDonut } from '../unescap-viz/new-pie-donut';
import { Sankey } from '../unescap-viz/sankey';
// import { SankeyCircos } from '../unescap-viz/circos'

export default {
  name: 'UnescapChart',
  components: {
  },
  props: {
    data: {
      type: Object,
      default: undefined
    }
  },
  data: function () {
    return {
      test: null
    };
  },
  watch: {
    data: function () {
      this.renderChart();
    }
  },
  mounted () {
    this.renderChart();
  },
  methods: {
    renderChart: function () {
      // console.log('renderChart !!');
      if (this.data) {
        if (this.data.type === 'sankey') {
          this.renderSankey();
        }
      }
    },
    renderSankey: function () {
      const inputData = _.cloneDeep(this.data);
      // console.log('renderSankey', inputData);

      if (this.$refs.chartContainerRef === undefined) return;
      if (inputData.type !== 'sankey') return;

      const setting = {
        ...inputData.setting,
        $el: d3Select(this.$refs.chartContainerRef),
        onClick: data => {
          // console.log('Sankey:onClick', data);
        },
        onHover: data => {
          // console.log('Sankey:onHover', data);
        }
      };
      const chart = new Sankey(setting);
    }
  }
};

</script>

<style lang="scss">
</style>
